<template>
  <div
    :id="questionId"
    :type="attributeType"
    class="questionModel"
    @clearValue="clearValue()"
    @disableInput="disableInput()"
    @enableInput="enableInput()"
    @enableRequired="enableRequired()"
    @removeRequired="removeRequired()"
  >
    <b-row class="mx-0">
      <b-col cols="10">
        <label class="questionLabelStyle"
          ><span v-if="isRequired" class="requiredStar">* </span>{{ label }}</label
        >

        <div v-if="helpText">
          <p class="helpTextStyle"><span v-html="helpText"></span></p>
        </div>
      </b-col>
      <b-col>
        <response-history
          v-show="numberValueId"
          :questionId="questionId"
          :surveyType="validationsType"
        />
      </b-col>
    </b-row>
    <b-col>
      <validation-observer ref="observer">
        <validation-provider
          ref="provider"
          v-slot="validationContext"
          :rules="`${isRequired ? 'required' : ''}`"
          name="numberProvider"
        >
          <b-form-input
            :id="questionId + '_value'"
            ref="number"
            v-model="numberValue"
            :name="name"
            :state="getValidationState(validationContext)"
            :type="inputType"
            aria-describedby="validationFeedback"
            class="w-100"
            maxlength="255"
            @input="changeItem($event)"
            @keydown="keyCheck"
            @paste.prevent
          />
          <b-form-invalid-feedback id="validationFeedback"
            >{{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </validation-provider>
      </validation-observer>
    </b-col>
    <br />
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import ResponseHistory from './ResponseHistory.vue';

  export default {
    name: 'Number',
    components: {
      ResponseHistory,
    },
    props: [
      'label',
      'dependencyMap',
      'questionId',
      'answer',
      'dependentQuestion',
      'requiredQuestions',
      'attributeType',
      'name',
      'validationsType',
      'helpText',
      'decimalPlaces',
    ],
    data() {
      return {
        inputType: 'number',
        numberValue: '',
        isRequired: false,
        regex: null,
        decimalDigits: '\\d',
        acceptedCodes: ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'],
      };
    },
    watch: {
      async validationTrigger(newVal, oldVal) {
        if (
          this.requiredQuestions.includes(this.questionId) &&
          newVal.includes(this.validationsType)
        ) {
          let data = [];
          data[0] = this.questionId;
          data[1] = await this.$refs.observer.validate();
          this.$store.commit(this.validationsType, data);
        }
      },
    },
    computed: {
      ...mapGetters(['validationTrigger']),
      numberValueId() {
        if (this.answer === undefined) {
          return undefined;
        } else {
          return this.answer[0]['Id'];
        }
      },
    },
    mounted() {
      if (document.getElementById(this.questionId).classList.contains('hideElement')) {
        this.isRequired = false;
        this.$nextTick(() => {
          this.$refs.observer.reset();
        });
      }
    },
    created() {
      if (this.requiredQuestions.includes(this.questionId)) {
        this.isRequired = true;
      }
      if (this.answer !== undefined) {
        this.numberValue = this.answer[0]['Saved_Value__c'];
        this.emitValue(this.answer[0]['Saved_Value__c']);
      } else {
        this.numberValue = '';
      }
      if (this.decimalPlaces !== undefined) {
        this.inputType = 'text';
        this.decimalDigits = this.decimalDigits.repeat(this.decimalPlaces);
        this.regex = new RegExp(`^\\d+\\.${this.decimalDigits}$`);
      }
    },
    methods: {
      ...mapActions(['dirtySurvey']),
      keyCheck($event) {
        if (this.decimalPlaces !== undefined && this.decimalPlaces == 0) {
          this.verifyIntegers($event);
        } else if (this.decimalPlaces !== undefined && this.decimalPlaces > 0) {
          this.verifyDecimals($event);
        }
      },
      verifyIntegers($event) {
        if (($event.key >= '0' && $event.key <= '9') || this.acceptedCodes.includes($event.code)) {
        } else {
          $event.preventDefault();
        }
      },
      verifyDecimals($event) {
        if (this.numberValue.includes('.') && $event.key === '.') {
          $event.preventDefault();
        }
        if (
          ($event.key >= '0' && $event.key <= '9') ||
          $event.key === '.' ||
          this.acceptedCodes.includes($event.code)
        ) {
        } else {
          $event.preventDefault();
        }
        if (!this.regex.test(this.numberValue) || this.acceptedCodes.includes($event.code)) {
        } else {
          $event.preventDefault();
        }
      },
      getValidationState({ dirty, validated, valid = null, required }) {
        if (required == true) {
          return dirty || validated ? valid : null;
        }
      },
      removeRequired() {
        this.isRequired = false;
      },
      enableRequired() {
        if (this.requiredQuestions.includes(this.questionId)) {
          this.isRequired = true;
          this.$refs.observer.validate();
        }
      },
      changeItem(event) {
        this.dirtySurvey(this.validationsType);
        if (event !== '') {
          let lastDigitIndex = event.length - 1;
          if (event[lastDigitIndex] == '.') {
            event = event.slice(0, lastDigitIndex);
          }
        }
        this.$emit('input', { value: event, id: this.numberValueId });
      },
      emitValue(savedValue) {
        this.$emit('input', { value: savedValue, id: this.numberValueId });
      },
      clearValue() {
        this.numberValue = '';
        this.$nextTick(() => {
          this.$refs.observer.reset();
        });
        this.changeItem('');
      },
      disableInput() {
        document.getElementById(this.questionId).classList.add('hideElement', 'pl-5');
        document.getElementById(this.questionId + '_value').setAttribute('hideElement', 'true');
      },
      enableInput() {
        document.getElementById(this.questionId).classList.remove('hideElement');
        document.getElementById(this.questionId + '_value').removeAttribute('hideElement');
      },
    },
  };
</script>
